import React from 'react';
import { Popover, Button, Select, Icon, Radio } from 'antd';

const { Option } = Select;

const getSortedCountries = (countries = []) => {
  const priority = countries?.filter((c) => c.priority);
  const rest = countries?.filter((c) => !c.priority);
  return [...priority, ...rest];
};

export const NonVerifiedCountry = ({
  onChange,
  onChangeDefine,
  countries = [],
  params,
  radioValue
}) => {
  const handleRadioChange = (e) => {
    const val = e.target.value;
    if (val === radioValue) {
      onChangeDefine(null);
      return;
    }
    onChangeDefine(e);
  };

  const handleSelectChange = (value) => {
    if (value && value.length > 0) {
      onChangeDefine(null);
    }
    onChange({ ...params, value });
  };

  const sortedCountries = getSortedCountries(countries ?? []);

  const content = (
    <>
      <Radio.Group
        style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
        value={radioValue || null}
        onChange={handleRadioChange}
      >
        <Radio value='priority' style={{ marginBottom: 4 }}>
          Priority Countries
        </Radio>
        <Radio value='undefineNonCountryClickhouse'>No Country Defined</Radio>
      </Radio.Group>

      <Select
        value={params?.value}
        mode='multiple'
        style={{ width: 180 }}
        allowClear
        placeholder='Non-verified country'
        onChange={handleSelectChange}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().startsWith(input.toLowerCase())
        }
      >
        {sortedCountries.map((country) => (
          <Option
            key={country.alpha3Code}
            value={country.fullName}
            style={country.priority ? { fontWeight: 600 } : {}}
          >
            {country.fullName}
          </Option>
        ))}
      </Select>
    </>
  );

  return (
    <Popover content={content} title='Non-verified country' trigger='click'>
      <Button className='sighting-filter' style={{ width: '10%' }}>
        Non-verified country
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
